import { render, staticRenderFns } from "./BookingPrestaInvoices.vue?vue&type=template&id=f19c6884&scoped=true"
import script from "./BookingPrestaInvoices.vue?vue&type=script&lang=js"
export * from "./BookingPrestaInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19c6884",
  null
  
)

export default component.exports